<template>
  <div>
    <v-layout row wrap v-if="!loading">
      <v-flex xs12>
        <v-autocomplete
          v-model="entry.customer"
          :items="items"
          :loading="autocomplete.isLoading"
          :search-input.sync="autocomplete.search"
          color="black"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="name"
          :label="$vuetify.t('$vuetify.lobis.selectCustomer')"
          :placeholder="$vuetify.t('$vuetify.lobis.queryCustomer')"
          prepend-icon="mdi-database-search"
          return-object
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12>
        <v-autocomplete
          v-if="entry.customer && entry.customer.projects"
          v-model="entry.project"
          :items="entry.customer.projects"
          color="black"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          :label="$vuetify.t('$vuetify.lobis.selectProject')"
          :placeholder="$vuetify.t('$vuetify.lobis.queryProject')"
          prepend-icon="mdi-database-search"
          return-object
        >
        </v-autocomplete>
      </v-flex>
      <v-divider></v-divider>
      <div v-if="entry.customer">
        <v-divider></v-divider>
        <v-flex xs12>
          <h3>Artikel:</h3>
        </v-flex>
        <v-data-table
            :items="entry.articleEntries"
            class="elevation-1"
            loading="true"
            hide-actions
            hide-headers
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.article.code }}</td>
                <td>{{ props.item.article.name }}</td>
                <td>{{ props.item.quantity }} {{ props.item.article.unit }}</td>
                <td @click="deleteArticleentry(props.item)"><v-icon>delete</v-icon></td>
            </template>
            <template slot="no-data">
                <p>Es gibt noch keine Einträge für diese Position</p>
            </template>
        </v-data-table>
        <v-flex xs12>
          <v-btn
            v-if="!articleDialog"
            color="primary"
            dark
            @click="articleDialog = true"
          >Artikel hinzufügen</v-btn>
        </v-flex>
        <v-dialog
          v-model="articleDialog"
          persistent
          max-width="600px"
        >

          <v-card>
            <v-card-title>
              <span class="headline">Artikel hinzufügen</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs9>
                    <v-autocomplete
                      v-model="article"
                      :items="articles"
                      color="black"
                      hide-no-data
                      hide-selected
                      item-text="name"
                      item-value="id"
                      label="Artikel auswählen"
                      placeholder="Artikel auswählen.."
                      prepend-icon="mdi-database-search"
                      return-object
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex
                    xs3
                  >
                    <v-text-field
                      label="Menge"
                      v-model="quantity"
                      :suffix=article.unit
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-if="article.code == ''"
                      v-model="article.name"
                      label="Beschreibung"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click="articleDialog = false"
              >Abbrechen</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="saveArticleEntry()"
              >Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-flex xs12>
          <v-textarea
            label="Beschreibung"
            v-model="entry.description"
          ></v-textarea>
      </v-flex>
      <v-btn
        color="primary"
        dark
        @click="saveOrder()"
      >Bestellung senden</v-btn>
      </div>
    </v-layout>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        dark
      >
        <v-card-text>
          Daten werden geladen..
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apiCall from '../../utils/api'
import Datepicker from '../Formcomponents/Datepicker.vue'
import Timepicker from '../Formcomponents/Timepicker.vue'
import { MATERIALORDER_SAVE } from '../../store/actions/materialorder'

export default {
  components: {
    'datepicker': Datepicker,
    'timepicker': Timepicker
  },
  data () {
    return {
      autocomplete: {
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        search: null
      },
      loading: false,
      TimeentryDescription: '',
      worker: null,
      article: null,
      articles: [
        {
          code: '2160V',
          name: 'Fräsen des Estriches',
          unit: 'std'
        },
        {
          code: '0026',
          name: 'LobiBOND Level Plus NM 20',
          unit: 'kg'
        },
        {
          code: '11972',
          name: 'LobiBOND Primer DX9',
          unit: 'kg'
        },
        {
          code: '6045',
          name: 'Füll- und Reparaturmasse SF83 fine',
          unit: 'kg'
        },
        {
          code: '6047',
          name: 'Schnellspachtelmasse SL52',
          unit: 'kg'
        },
        {
          code: '3609',
          name: 'Holzspachtelmasse NH75 (20kg)',
          unit: 'kg'
        },
        {
          code: '11720',
          name: 'LobiBOND Holzbodenklebstoff 1-K MS 33',
          unit: 'kg'
        },
        {
          code: '3079',
          name: 'LobiBOND 2-k PU 55 10 kg',
          unit: 'kg'
        },
        {
          code: '6507',
          name: 'LobiBOND Flexkleber Extra 30 Maxi grau',
          unit: 'kg'
        },
        {
          code: '8732',
          name: 'LobiBOND Flexkleber Extra 30 Maxi weiß',
          unit: 'kg'
        },
        {
          code: '',
          name: 'manueller Artikel',
          unit: ''
        }
      ],
      timeDialog: false,
      on: false,
      date: null,
      duration: null,
      articleDialog: false,
      quantity: 0,
      expand: false,
      entry: {
        id: null,
        customer: null,
        project: null,
        timeEntries: [],
        articleEntries: [],
        description: ''
      },
      description: ''
    }
  },
  computed: {
    // ...mapGetters([
    //   REGIE_TIMEENTRIES_INDEX, REGIE_ARTICLEENTRIES_INDEX, REGIE_CURRENT, REGIE_GETWORKERS
    // ]),
    items () {
      return this.autocomplete.entries.map(entry => {
        const Description = entry.name

        return Object.assign({}, entry, { Description })
      })
    }
  },
  created () {
    this.article = this.articles[0]
    // this.$store.dispatch(REGIE_GETWORKERS)
    // if (this.$route.params.id) {
    //   this.loading = true
    //   this.$store.dispatch(REGIE_GET, this.$route.params.id).then(resp => {
    //     // resp.customer.Description = resp.customer.name
    //     this.autocomplete.entries = [...this.autocomplete.entries, resp.customer]
    //     this.entry = resp
    //     this.entry.id = this.$route.params.id
    //     this.loading = false
    //   })
    // }
  },
  watch: {
    'autocomplete.search' (val) {
      // Items have already been requested
      if (this.autocomplete.isLoading) return

      this.autocomplete.isLoading = true

      // Lazily load input items
      apiCall({ url: 'api/customers', method: 'POST', q: val }).then(resp => {
        this.autocomplete.entries = resp
      }).catch(err => {
        console.log(err)
      }).finally(() => (this.autocomplete.isLoading = false))
    }
  },
  methods: {
    saveArticleEntry () {
      this.entry.articleEntries = [...this.entry.articleEntries, {
        article: this.article,
        quantity: this.quantity
      }]
      this.articleDialog = false
    },
    saveOrder () {
      this.$store.dispatch(MATERIALORDER_SAVE, this.entry).then(resp => {
        this.$swal({
          type: 'success',
          title: 'Eintrag erfolgreich hinzugefügt!',
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'RegieIndex' })
      })
    },
    deleteTimeentry (timeentry) {
      const index = this.entry.timeEntries.indexOf(timeentry)
      this.entry.timeEntries.splice(index, 1)
    },
    deleteArticleentry (articleentry) {
      const index = this.entry.articleEntries.indexOf(articleentry)
      this.entry.articleEntries.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MaterialOrder/Create.vue